import { InputRule } from 'prosemirror-inputrules';
import { MarkType } from 'prosemirror-model';

import { ensureHttps } from '../utils';

export function typeLinkRule(markType: MarkType) {
  return new InputRule(
    /(https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b(?:[-a-zA-Z0-9@:%_+.~#?&//=]*))(\s|,|;|\)|:|(?:\.\s))$/g,
    (state, match, start, end) => {
      const link = ensureHttps(match[1]);
      return state.tr
        .insertText(link + match[2], start, end)
        .addMark(
          start,
          start + link.length,
          markType.create({ href: ensureHttps(match[1]) }),
        );
    },
  );
}
